import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 18a3 3 0 0 0 3 -3v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3v8a3 3 0 0 0 3 3","key":"svg-0"}],["path",{"d":"M9 20h6l-3 -5l-3 5","key":"svg-1"}]]

const IconShareplay = createReactComponent('outline', 'shareplay', 'Shareplay', __iconNode);

export default IconShareplay;